import React, { useState, useRef, useEffect } from 'react';
import Icon from '../AppIcon';
import Image from '../AppImage';

const UserProfileDropdown = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event?.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    console.log('Logout clicked');
    setIsOpen(false);
  };

  const handleSettings = () => {
    console.log('Settings clicked');
    setIsOpen(false);
  };

  const handleProfile = () => {
    console.log('Profile clicked');
    setIsOpen(false);
  };

  const getRoleLabel = (role) => {
    const roleMap = {
      admin: 'Administrator',
      center_manager: 'Center Manager',
      sales: 'Sales Representative'
    };
    return roleMap?.[role] || role;
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={handleToggle}
        className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-muted transition-smooth press-scale"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center overflow-hidden">
          {user?.avatar ? (
            <Image 
              src={user?.avatar} 
              alt={user?.name || 'User'} 
              className="w-full h-full object-cover"
            />
          ) : (
            <Icon name="User" size={20} color="var(--color-primary-foreground)" />
          )}
        </div>
        <div className="flex-1 text-left">
          <p className="text-sm font-medium text-foreground truncate">
            {user?.name || 'User Name'}
          </p>
          <p className="text-xs text-muted-foreground truncate caption">
            {getRoleLabel(user?.role)}
          </p>
        </div>
        <Icon 
          name={isOpen ? 'ChevronUp' : 'ChevronDown'} 
          size={16} 
          className="transition-transform duration-250"
        />
      </button>
      {isOpen && (
        <div className="absolute bottom-full left-0 right-0 mb-2 bg-popover border border-[var(--color-border)] rounded-lg shadow-elevation-3 overflow-hidden z-dropdown">
          <button
            onClick={handleProfile}
            className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted transition-smooth text-left"
          >
            <Icon name="User" size={18} />
            <span className="text-sm">My Profile</span>
          </button>
          <button
            onClick={handleSettings}
            className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted transition-smooth text-left"
          >
            <Icon name="Settings" size={18} />
            <span className="text-sm">Settings</span>
          </button>
          <div className="border-t border-[var(--color-border)]" />
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 hover:bg-destructive hover:text-destructive-foreground transition-smooth text-left"
          >
            <Icon name="LogOut" size={18} />
            <span className="text-sm">Logout</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfileDropdown;